import { render } from "./SlotVsDepositByProject.vue?vue&type=template&id=61a827e6"
import script from "./SlotVsDepositByProject.vue?vue&type=script&lang=js"
export * from "./SlotVsDepositByProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__